import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { validateInput } from "../../../schema/inputValidation";
import { sendOtpApi } from "../../../services/auth";
import { toastMessage } from "../../../utils/toastMessage";
import { decryptData, encryptData } from "../../../utils/dataCipher";
import { auth } from "../../../schema/auth/auth";
import { GoArrowRight } from "react-icons/go";
import { LoadingButton } from "../../../components/header/form";
import { areMandatoryFieldsFilled } from "../../../utils/inputValueValidation";

const LoginLandingPage = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let info = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(info).length) {
    encryptedData = decryptData(info);
  }
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [phone, setPhone] = useState({
    dialCode: encryptedData?.dialCode || "",
    number: encryptedData?.number || "",
    completeMobile: encryptedData?.dialCode + encryptedData?.number || "+1",
  });
  const [error, setError] = useState({});

  const handlePhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country.dialCode, "");
    setPhone({
      number: phoneWithoutCountryCode,
      completeMobile: `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      dialCode: `${country?.dialCode}`,
    });
  };

  const validation = () => {
    const { errors, status } = validateInput(
      { number: phone?.number },
      "loginSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };
  const requiredFields = ["number"];

  const formFields = {
    number: phone?.number,
  };
  // console.log('phone', phone)
  const handleSendOtp = async () => {
    if (validation()) {
      try {
        setLoading(true);
        const { data } = await sendOtpApi({
          dialCode: `${phone?.dialCode}`,
          number: phone?.number,
        });
        // console.log('data', data)
        const isSuccess = data?.success;
        toastMessage(data?.message, isSuccess ? "success" : "error", "sendOtp");
        if (isSuccess) {
          const data = {
            number: phone?.number,
            dialCode: `${phone?.dialCode}`,
          };
          navigate(`/otp?info=${encryptData(data)}`);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <div className="login_account">
      <div className="login_wrapper">
        <div className="login_heading_text">
          <h2>Login to Your Account</h2>
          <p>Glad to see you again login to your account below</p>
        </div>

        <div className="form_field">
          <label className="label">Enter your mobile number</label>
          <div className="phone_input">
            <PhoneInput
              country={"ca"}
              value={phone?.completeMobile || "+1"}
              enableSearch={true}
              placeholder={"Enter Mobile Number"}
              countryCodeEditable={false}
              onChange={handlePhoneChange}
            />
          </div>
          <p className="confirmation_text">
            We will send you a confirmation code to verify your number
          </p>

          {/* <button className="button">
                        Next
                        <span>
                            <TiArrowRight />
                        </span>
                    </button> */}
          <LoadingButton
            loading={loading}
            isDisabled={
              phone?.number < 3 &&
              phone?.number > 15 &&
              !areMandatoryFieldsFilled(formFields, requiredFields)
            }
            className={`button next-button ${
              !areMandatoryFieldsFilled(formFields, requiredFields)
                ? "cstm_disabled_btn"
                : ""
            }`}
            onClick={handleSendOtp}
          >
            Next &nbsp;
            <GoArrowRight />
          </LoadingButton>
        </div>

        <div className="sign_up_tag">
          <p>
            Don’t have an account?{" "}
            <span>
              <Link to="/login">Sign Up</Link>
            </span>
          </p>
        </div>
      </div>
      <p className="case_issue">
        In case of any issues during login/sign-up, drop a WhatsApp at +1 905
        490 1212
      </p>
    </div>
  );
};

export default LoginLandingPage;
